import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import type { HierarchyDTO } from './useGetHierarchies';

export interface HierarchyPayload {
	name: string;
	role: string;
	description: string;
	farmer: { group?: string | null };
	consultant: { group?: string | null };
	company: { group?: string | null };
	master: { group?: string | null };
}

export const useCreateHierarchy = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (payload: HierarchyPayload) => {
			try {
				const { data } = await api.post<HierarchyDTO>('/hierarchy/create', payload);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar hierarquia');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['hierarchies'] });
		},
	});
};
